import _createIconComponent from "./utils/createIconComponent";
const _createIconComponent2 = _interopRequireDefault(_createIconComponent);
import _react from "react";
const _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
const IconHexagonSolid = (0, _createIconComponent2.default)({
  content: _react2.default.createElement(
    "g",
    null,
    _react2.default.createElement("path", {
      d: "M9 .577a2 2 0 0 1 2 0l7.526 4.346a2 2 0 0 1 1 1.732v8.69a2 2 0 0 1-1 1.732L11 21.423a2 2 0 0 1-2 0l-7.526-4.346a2 2 0 0 1-1-1.732v-8.69a2 2 0 0 1 1-1.732L9 .577z",
    })
  ),
  height: 22,
  width: 20,
});
IconHexagonSolid.displayName = "IconHexagonSolid";
const _default = IconHexagonSolid;
export { _default as default };
